import React from "react";

function Social() {
  return <div>Social</div>;
}

export default Social;
